/*
 * サブシステム名：設定その他
 * 機能名：データ取込
 */

import flowMixin from '@/mixins/flowMixins'
import { mapGetters } from 'vuex'
import dayjs from 'dayjs'

import DdCustomButton from '@/components/DdCustomButton'
import DdDropDown from '@/components/DdDropDown'
import DdFileInput from '@/components/DdFileInput'
import DdIconButtonWithTooltip from '@/components/DdIconButtonWithTooltip'
import DdNarrowDownTextBox from '@/components/DdNarrowDownTextBox'
import DdRadioButton from '@/components/DdRadioButton'
import DdSelectItemsPerPage from '@/components/DdSelectItemsPerPage'
import DdSubHeader from '@/components/DdSubHeader'
import DdTransparentButton from '@/components/DdTransparentButton'

export default {
  name: 'DataImportList',
  mixins: [flowMixin],
  components: {
    DdCustomButton,
    DdDropDown,
    DdFileInput,
    DdIconButtonWithTooltip,
    DdNarrowDownTextBox,
    DdRadioButton,
    DdSelectItemsPerPage,
    DdSubHeader,
    DdTransparentButton
  },
  data: () => ({
    itemsPerPage: 25,
    page: 1,
    isConditionHide: false,
    isAfterSearch: false,
    expansionPanel: [0, 1],
    conditions: {
      fileFormatCd: '',
      kaishaCd: '',
      isTemplateOnlyFlg: true,
      dataFile: null,
      torihikisakiKbn: '0'
    },
    modeKengen: 0
  }),
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      helpUseFlg: 'DDMasters/helpUseFlg',
      currentKaishaCode: 'users/currentKaishaCode',
      kubunList: 'DDMasters/msysKubun',
      fileFormatNm: 'DDMasters/mstFileFormatKihon'
    }),
    filteredFileFormatNm () {
      var defArray = [{ value: null, text: '未選択' }]
      const resultArray = this.fileFormatNm.filter(function (elem) {
        return elem.fileFormatCd < '900' && (elem.fileFormatKbn === '1' || elem.fileFormatKbn === '3')
      }).map(function (elem) {
        elem.value = elem.fileFormatCd
        elem.text = elem.fileFormatNm
        return elem
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.fileFormatCd > elem2.fileFormatCd) { return 1 }
        if (elem1.fileFormatCd === elem2.fileFormatCd) { return 0 }
        return -1
      })
      return defArray.concat(resultArray)
    },
    filteredProcessKbn () {
      return this.kubunList.filter(function (elem) {
        return elem.kbnShuruiCd === 'KBN042'
      }).map(function (elem) {
        elem.code = elem.code.trim()
        return elem
      }).filter((e) => {
        // 作業はリストアは使えないように
        if (e.code === '2' && (this.conditions.fileFormatCd === '102' || this.conditions.fileFormatCd === '103')) {
          return false
        }
        return true
      })
    },
    selectedFileFormatName () {
      const self = this
      return this.fileFormatNm.filter(function (elem) {
        return elem.fileFormatCd === self.conditions.fileFormatCd
      }).map(function (elem) {
        elem.fileFormatNm = elem.fileFormatNm.trim()
        return elem
      })
    },
    isValidImportButton () {
      if (this.modeKengen === 0) {
        return false
      }
      return true
    },
    isValidCSVTemplate () {
      return ![undefined, null, ''].includes(this.conditions.fileFormatCd)
    },
    filteredRows () {
      return this.rows.map((elem) => {
        elem.importStartDisp = elem.importStart ? dayjs(elem.importStart).format('YYYY/MM/DD HH:mm:ss') : ''
        elem.importEndDisp = elem.importEnd ? dayjs(elem.importEnd).format('YYYY/MM/DD HH:mm:ss') : ''
        // elem.keiyakuKihonKingakuDisp = filter.numericFormatter(elem.keiyakuKihonKingaku)

        return elem
      })
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
    this.page = 1
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['mstfileformatkihon', 'msyskubun'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            self.headers = [
              { text: '詳細', value: 'detailref', align: 'center' },
              { text: '取込指示日時', value: 'importStartDisp', align: 'center' },
              { text: '取込終了日時', value: 'importEndDisp', align: 'center' },
              { text: '取込指示者', value: 'importUserNm' },
              { text: '取込ファイル名', value: 'importFileName' },
              { text: '種類', value: 'fileFormatNm' },
              { text: '方法', value: 'codeNm' },
              { text: '取込結果', value: 'exportResult' },
              { text: '読込行数', value: 'importRowCnt' },
              { text: 'エラー行数', value: 'errorRowCnt' },
              { text: 'エラー情報', value: 'errorMsg' }
            ]
            resolve()
          }).then(() => {
            // 取込履歴一覧取得
            return new Promise(resolve => {
              this.HttpClient
                .post('/api/v1/vwCD2utld0010/search', { max: '899' })
                .then((data) => {
                  if (data.isValid) {
                    this.rows = data.payload
                  } else {
                    this.rows = []
                  }
                  resolve(data)
                })
            })
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.conditions = {
              fileFormatCd: null,
              processKbn: '0',
              kaishaCd: self.currentKaishaCode,
              isTemplateOnlyFlg: true,
              filePath: '',
              fileName: '',
              dataFile: null
            }
            self.page = 1
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          // ユーザ保存項目の復元
          self.conditions = { ...self.conditions, ...c }
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            self.searchText = c.cache.value.searchText || ''
            self.rows = c.cache.value.rows || []
          })
        },
        settingButtonStatePromise: (kengen) => {
          return new Promise(resolve => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }
            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    clear: function () {
      console.log('clear pushed')
      const self = this
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            self.conditions = {
              fileFormatCd: null,
              kaishaCd: self.currentKaishaCode,
              isTemplateOnlyFlg: true,
              processKbn: '0',
              filePath: '',
              fileName: '',
              dataFile: null
            }
            self.page = 1
            self.searchText = ''
            self.isConditionHide = false
            // this.rows = []
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onTorikomiButtonClick: function (e) {
      console.log('cklick')
      if (this.validateAll(this.$refs)) {
        this.Effects.loadStart()
        console.log('TorikoMI start', e)
        this.HttpClient.post('/api/v1/D2UTLD0010/Exec', this.conditions)
          .then((data) => {
            if (data.isValid) {
              console.log('retdata', data)
              this.transition(0, { id: data.payload, edit: 1 })
            } else {
              this.setSummaryMessage(data.summaryMessage)
              this.Effects.loadComplete()
            }
          }).catch((e) => {
            console.log('error', e)
            this.setSummaryMessage(e.message)
            this.Effects.loadComplete()
          })
      }
    },
    onClearButtonClick: function (e) {
      console.log('clear pushed')
      this.Effects.loadStart()
      this.clear()
    },
    onRowDoubleClick: function (e, f) {
      console.log(e, f)
      this.Effects.loadStart()
      this.transition(0, { id: f.item.id, edit: 0 })
    },
    onRowDetailButtonClick: function (item) {
      // 画面遷移
      this.Effects.loadStart()
      this.transition(0, { id: item.id, edit: 0 })
    },
    searchValidate: function () {
      return true
    },
    storeFileInfo: function (file) {
      console.log('file selected', file)

      if (file === undefined || file === null) {
        this.conditions.fileData = ''
        this.conditions.fileName = ''
        return
      }
      this.conditions.fileName = file.name

      const fr = new FileReader()
      fr.readAsDataURL(file)
      fr.addEventListener('load', () => {
        this.conditions.fileData = fr.result
      })
      console.log('file selected e')
    },
    isFileUtf8 (fileFormatCd) {
      const r = this.filteredFileFormatNm.find((p) => {
        return p.fileFormatCd === fileFormatCd
      })
      if (r && r.characterCodeKbn) {
        if (r.characterCodeKbn.toLowerCase() === 'ms932' || r.characterCodeKbn.toLowerCase() === 'shift_jis' || r.characterCodeKbn.toLowerCase() === 'shift-jis') {
          return false
        }
      }
      return true
    },
    CSVtemplateClick: function (e) {
      // TODO call file export only headers
      // if (this.validateAll(this.$refs)) {
      this.Effects.loadStart()
      const self = this
      const isUtf8 = self.isFileUtf8(this.conditions.fileFormatCd)
      // self.HttpClient.post('/api/v1/TrExportHistory/export', self.conditions).then((data) => {
      if (isUtf8) {
        self.HttpClient.post('/api/v1/TrExportHistory/exportMapping', self.conditions).then((data) => {
          const bom = new Uint8Array([0xef, 0xbb, 0xbf])
          const blob = new Blob([bom, data], { type: 'text/csv' })
          const elem = document.getElementById('export')
          elem.href = window.URL.createObjectURL(blob)
          elem.download = self.selectedFileFormatName[0].text + '_テンプレート.csv'
          elem.click()
        }).then((data2) => {
          // self.initialize()
          this.Effects.loadComplete()
        })
      } else {
        this.HttpClient
          .requestFileByPost('/api/v1/TrExportHistory/exportMapping', this.conditions)
          .then((data) => {
            // エラー初期化
            this.clearSummaryMessage()
            if (data.invalidList !== undefined) {
              // エラーあり形式が返却された場合
              // エラー設定
              this._setMessages(data)
            } else {
              // CSVデータ形式（エラーなし形式）が返却された場合
              // CSV出力
              // const bom = new Uint8Array([0xEF, 0xBB, 0xBF])
              const blob = new Blob([data], { type: 'text/csv' })
              const elem = document.getElementById('export')
              elem.href = window.URL.createObjectURL(blob)
              elem.download = self.selectedFileFormatName[0].text + '_テンプレート.csv'
              elem.click()
            }
          }).then((data2) => {
            // self.initialize()
            this.Effects.loadComplete()
          })
      }
      // }
    },

    changeItemsPerPage: function (e) {
      console.log('changeItemsPerPage', e)
      this.itemsPerPage = e
      // 子コンポーネントへの反映
      this.$nextTick().then(() => {
        this.$refs.pagination1.syncPagination(this.itemsPerPage, this.page)
        this.$refs.pagination2.syncPagination(this.itemsPerPage, this.page)
      })
    },
    changePage: function (e) {
      this.page = e
      // 子コンポーネントへの反映
      this.$nextTick().then(() => {
        this.$refs.pagination1.syncPagination(this.itemsPerPage, this.page)
        this.$refs.pagination2.syncPagination(this.itemsPerPage, this.page)
      })
    }
  }
}
